import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Launch from "@/pages/Launch";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/launch" element={<Launch />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
